import { render, staticRenderFns } from "./classifyStatistics.vue?vue&type=template&id=0b9e154b&scoped=true&"
import script from "./classifyStatistics.vue?vue&type=script&lang=js&"
export * from "./classifyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./classifyStatistics.vue?vue&type=style&index=0&id=0b9e154b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e154b",
  null
  
)

export default component.exports